module.exports = __webpack_public_path__ + "f714bb71f399851edcdea63667719565.svg";